/* eslint import/no-namespace:0 */
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux';
import { PropTypes } from "prop-types"
import { reduxForm, Field, change, formValueSelector, getFormSyncErrors } from 'redux-form'
import { Col, FormGroup, Row } from "react-bootstrap"
import Dialog from 'react-bootstrap-dialog'
import { isEmpty } from '../../../../utils/functions';
import { fetchMember, setSearchMode, savingAthlete, saveAdvancer, saveAlternate } from '../../../../redux/actions/action_postEvent';
import { renderField } from '../../../../modules/components/fieldcomponent'
import { orange, style, blue, red, lightgray, warning } from '../../../../utils/constants'
import InfoSaved from '../../../season/components/InfoSaved'
import ErrorList from '../../../season/components/ErrorList'

const FormName = 'postevent'
const spanClassName = `col-sm-12`

class NewAdvancerAlternate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      saved: false
    }
    this.handleSaveAthlete = this.handleSaveAthlete.bind(this);
    this.handleResetMember = this.handleResetMember.bind(this);
    this.handleResetSearch = this.handleResetSearch.bind(this);
    this.handleGetMemberInfo = this.handleGetMemberInfo.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleNegativeNumbers = this.handleNegativeNumbers.bind(this);
    this.handleNotToExceedLengthPrefix = this.handleNotToExceedLengthPrefix.bind(this);
    this.handleNotToExceedLengthSuffix = this.handleNotToExceedLengthSuffix.bind(this);
  }

  handleResetMember() {
    const { memberName, email, memberState, city, calculatedAge, gender, calculatedDivision,
      parentEmail, dispatch, memberRetrieved, norecordsfound, syncErrors } = this.props

    if (!isEmpty(memberName)) {
      dispatch(change(FormName, 'memberName', ''))
    }
    if (!isEmpty(email)) {
      dispatch(change(FormName, 'email', ''))
    }
    if (!isEmpty(memberState)) {
      dispatch(change(FormName, 'memberState', ''))
    }
    if (!isEmpty(city)) {
      dispatch(change(FormName, 'city', ''))
    }
    if (!isEmpty(calculatedAge))
    {
      dispatch(change(FormName, 'calculatedAge', ''))
    }
    if (!isEmpty(gender)) {
      dispatch(change(FormName, 'gender', ''))
    }
    if (!isEmpty(calculatedDivision)) {
      dispatch(change(FormName, 'calculatedDivision', ''))
    }
    if (!isEmpty(parentEmail)) {
      dispatch(change(FormName, 'parentEmail', ''))
    }
    if (memberRetrieved) {
      dispatch(change(FormName, 'memberRetrieved', false))
    }
    if (norecordsfound) {
      dispatch(change(FormName, 'norecordsfound', false))
    }
    if (syncErrors) {
      dispatch(change(FormName, 'syncErrors', null))
    }
  }

  handleResetSearch() {
    const { memberidprefix, memberidsuffix, dispatch } = this.props

    if (!isEmpty(memberidprefix)) {
      dispatch(change(FormName, 'memberidprefix', ''))
    }
    if (!isEmpty(memberidsuffix)) {
      dispatch(change(FormName, 'memberidsuffix', ''))
    }
  }

  handleGetMemberInfo(event) {
    const { dispatch, memberidprefix, memberidsuffix } = this.props
    event.preventDefault();
    dispatch(setSearchMode(true));
    dispatch(fetchMember(memberidprefix, memberidsuffix));
  }

  handleCancel() {
    const { onCancel } = this.props;
    this.handleResetMember();
    this.handleResetSearch();
    onCancel();
  }

  handleSaveAthlete(e) {
    e.preventDefault();
    const { athleteType, onSave, dispatch, address1, address2, birthDate, city, country, phoneNumber,
      email, firstName, lastName, memberState, zip, gender, eventId, memberidprefix, memberidsuffix,
      isBaseActive, isCollegiateYouth, isJuniorGoldActive, isJuniorGoldU12, isJuniorGoldU14, isJuniorGoldU16, isJuniorGoldU18,
      isJuniorGoldU15U17U20, isJuniorGoldU15U18, isJuniorGoldU20, isSpecialOlympicsAdult, isStandardAdult,
      isCollegiateAdult, isSpecialOlympicsYouth, isStandardYouth, middleInitial, membershipPurchaseDate, suffix,
      parentEmail, calculatedDivision, calculatedDivisionId, divisionHeldId } = this.props;
    const athlete = {
      eventId: eventId,
      divisionId: calculatedDivisionId,
      addressLine1: address1,
      addressLine2: address2,
      dob: birthDate,
      city: city,
      country: country,
      phoneNumber: phoneNumber,
      emailAddress: email,
      firstName: firstName,
      lastName: lastName,
      state: memberState,
      zip: zip,
      gender: gender,
      membershipId: `${memberidprefix}-${memberidsuffix}`,
      isBaseActive: isBaseActive,
      isCollegiateYouth: isCollegiateYouth,
      isCollegiateAdult: isCollegiateAdult,
      isJuniorGoldActive: isJuniorGoldActive,
      isJuniorGoldU12: isJuniorGoldU12,
      isJuniorGoldU14: isJuniorGoldU14,
      isJuniorGoldU16: isJuniorGoldU16,
      isJuniorGoldU18: isJuniorGoldU18,
      isJuniorGoldU15U18: isJuniorGoldU15U18,
      isJuniorGoldU20: isJuniorGoldU20,
      isJuniorGoldU15U17U20: isJuniorGoldU15U17U20,
      isSpecialOlympicsAdult: isSpecialOlympicsAdult,
      isSpecialOlympicsYouth: isSpecialOlympicsYouth,
      isStandardAdult: isStandardAdult,
      isStandardYouth: isStandardYouth,
      membershipPurchaseDate: membershipPurchaseDate,
      middleInitial: middleInitial,
      suffix: suffix,
      parentGuardianEmail: parentEmail,
      calculatedDivision: calculatedDivision
    }
    dispatch(savingAthlete());

    if (athleteType == 'Advancer') {
      dispatch(saveAdvancer(eventId, calculatedDivisionId, athlete, divisionHeldId));
    }
    else if (athleteType == 'Alternate') {
      dispatch(saveAlternate(eventId, calculatedDivisionId, athlete, divisionHeldId));
    }
    this.handleResetMember();
    this.handleResetSearch();
    onSave(athlete.membershipId);
  }

  handleNegativeNumbers(evt) {
    if (evt.which === 109 || evt.which === 189) {
      evt.preventDefault();
    }
  }

  handleNotToExceedLengthPrefix(evt) {
    const { value } = evt.target;
    if ((value.length > 4)) {
      return evt.target.value = value.substring(0, 4);
    }
  }

  handleNotToExceedLengthSuffix(evt) {
    const { value } = evt.target;
    if ((value.length > 7)) {
      return evt.target.value = value.substring(0, 7);
    }
  }

  render() {
    const { saved } = this.state
    const { searchMode, memberidprefix, memberidsuffix, syncErrors, memberRetrieved,
      divisionHeldId, mixedAgeDivisionsHeld, athleteType, norecordsfound } = this.props;
    const errors = Object.values(syncErrors);
    let divisionHeldName;
    let addAthlete;
    if (divisionHeldId !== undefined && divisionHeldId !== '-1') {
      const divisions = mixedAgeDivisionsHeld.filter(f => f.id === parseInt(divisionHeldId));
      if (divisions.length > 0) {
        divisionHeldName = <h4 style={{ color: blue, textDecoration: 'underline' }}>Division Held: {divisions[0].name}</h4>;
      }
    }
    if (athleteType == 'Advancer') {
      addAthlete = <h4 style={{ color: blue }}>{'Add Advancer'}</h4>;
    }
    else if (athleteType == 'Alternate') {
      addAthlete = <h4 style={{ color: blue }}>{'Add Alternate'}</h4>;
    }

    return (
      <div style={{ backgroundColor: 'white', padding: '10px', border: `1px solid ${lightgray}` }}>
        <Row>
          <Col xs={12}>
            {divisionHeldName}
            <Row>
              <Col xs={10}>
                {addAthlete}
              </Col>
            </Row>
            <Dialog ref={(el) => { this.dialog = el }} />
            {(errors.length > 0) && <ErrorList errors={errors} />}
            {
              norecordsfound !== undefined && norecordsfound &&
              <span className={spanClassName} style={{ color: warning, float: 'left' }}>
                <i className='fa fa-info-circle' style={{ paddingLeft: '0px', marginTop: '0px' }} />&nbsp;&nbsp;Athlete not found
              </span>
            }
            <Col md={12} lg={6} style={{ padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
              <FormGroup>
                <label className={style.lblattrsWide}>USBC Member ID</label>
                <Col sm={3} md={3} lg={3}>
                  <Field
                    className="form-control no-spinners"
                    placeholder='Prefix (#)'
                    component="input"
                    type='number'
                    name='memberidprefix'
                    onClick={this.handleResetMember}
                    onKeyDown={this.handleNegativeNumbers}
                    onKeyUp={this.handleNotToExceedLengthPrefix}
                  />
                </Col>
                <Col sm={3} md={3} lg={4} style={{ marginLeft: '-28px', minWidth: '130px' }}>
                  <Field
                    className="form-control no-spinners"
                    placeholder='Suffix (#)'
                    component="input"
                    type='number'
                    name='memberidsuffix'
                    onClick={this.handleResetMember}
                    onKeyDown={this.handleNegativeNumbers}
                    onKeyUp={this.handleNotToExceedLengthSuffix}
                  />
                </Col>
                <Col sm={1} lg={1} md={1}>
                  <span className="input-group-btn" sm={1} md={1} lg={1}>
                    <button
                      type="button"
                      className="btn btn-default"
                      id='button'
                      style={
                        {
                          marginLeft: '-32px', marginTop: '-1px', minHeight: '37px', maxWidth: '41px',
                          borderRadius: '0', color: orange
                        }
                      }
                      onClick={this.handleGetMemberInfo}
                      disabled={isEmpty(memberidprefix) || isEmpty(memberidsuffix) || errors.length > 0}>

                      <i className={searchMode === true ? "fa fa-spinner fa-spin" : "fa fa-search"} aria-hidden="true" />
                    </button>
                  </span>
                </Col>
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Name</label>
                <Field
                  name='memberName'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Email</label>
                <Field
                  name='email'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>State</label>
                <Field
                  name='memberState'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>City</label>
                <Field
                  name='city'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
            </Col>
            <Col md={12} lg={6} style={{ padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
              <FormGroup>
                <label className={style.lblattrs}>Age</label>
                <Field
                  name='calculatedAge'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Gender</label>
                <Field
                  name='gender'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Calculated Division</label>
                <Field
                  name='calculatedDivision'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                  disabled='disabled'
                />
              </FormGroup>
              <FormGroup>
                <label className={style.lblattrs}>Parent/Guardian Email</label>
                <Field
                  name='parentEmail'
                  labelattrs={style.lblattrsWide}
                  inputattrs={style.inputattrsSmall}
                  component={renderField}
                />
              </FormGroup>
            </Col>
            <FormGroup >
              <Col smOffset={5} sm={10}>
                <button type="button" className="btn btn-default" style={{ color: blue, fontWeight: 800, marginTop: '15px' }} onClick={this.handleSaveAthlete} disabled={errors.length > 0 || !memberRetrieved} >
                  <i className={saved ? 'fa fa-spinner fa-spin' : "fa fa-save"} aria-hidden="true" /> &nbsp;&nbsp;Save Changes
                </button>
                <button type="button" className="btn btn-default" style={{ color: red, fontWeight: 800, marginTop: '15px', marginLeft: '10px' }} onClick={this.handleCancel}>
                  <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Cancel
                </button>
                {
                  saved && (<InfoSaved custommessage='Saved successfully.' />)
                }
              </Col>
            </FormGroup>
          </Col>
        </Row>
      </div>)
  }
}

NewAdvancerAlternate.propTypes = {
  dispatch: PropTypes.func,
  eventId: PropTypes.number,
  athleteType: PropTypes.string,
  memberName: PropTypes.string,
  email: PropTypes.string,
  memberState: PropTypes.string,
  city: PropTypes.string,
  calculatedAge: PropTypes.number,
  gender: PropTypes.string,
  calculatedDivision: PropTypes.string,
  calculatedDivisionId: PropTypes.string,
  parentEmail: PropTypes.string,
  searchMode: PropTypes.bool,
  memberidsuffix: PropTypes.string,
  memberidprefix: PropTypes.string,
  syncErrors: PropTypes.object,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  address1: PropTypes.string,
  address2: PropTypes.string,
  birthDate: PropTypes.string,
  country: PropTypes.string,
  phoneNumber: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  zip: PropTypes.string,
  memberRetrieved: PropTypes.bool,
  isBaseActive: PropTypes.bool,
  isCollegiateAdult: PropTypes.bool,
  isCollegiateYouth: PropTypes.bool,
  isJuniorGoldActive: PropTypes.bool,
  isJuniorGoldU12: PropTypes.bool,
  isJuniorGoldU14: PropTypes.bool,
  isJuniorGoldU16: PropTypes.bool,
  isJuniorGoldU18: PropTypes.bool,
  isJuniorGoldU15U18: PropTypes.bool,
  isJuniorGoldU20: PropTypes.bool,
  isJuniorGoldU15U17U20: PropTypes.bool,
  isSpecialOlympicsAdult: PropTypes.bool,
  isSpecialOlympicsYouth: PropTypes.bool,
  isStandardAdult: PropTypes.bool,
  isStandardYouth: PropTypes.bool,
  membershipPurchaseDate: PropTypes.string,
  middleInitial: PropTypes.string,
  suffix: PropTypes.string,
  divisionHeldId: PropTypes.string,
  norecordsfound: PropTypes.bool,
  mixedAgeDivisionsHeld: PropTypes.array
}

function mapStateToProps(state, ownProps) {

  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const syncErrors = getFormSyncErrors(formName)(state)
  const searchMode = selector(state, 'searchMode')
  const eventId = selector(state, 'eventId')
  const memberidprefix = selector(state, 'memberidprefix')
  const memberidsuffix = selector(state, 'memberidsuffix')
  const memberName = selector(state, 'memberName')
  const email = selector(state, 'email')
  const memberState = selector(state, 'memberState')
  const city = selector(state, 'city')
  const calculatedAge = selector(state, 'calculatedAge')
  const gender = selector(state, 'gender')
  const calculatedDivision = selector(state, 'calculatedDivision')
  const calculatedDivisionId = selector(state, 'calculatedDivisionId')
  const parentEmail = selector(state, 'parentEmail')
  const address1 = selector(state, 'address1')
  const address2 = selector(state, 'address2')
  const birthDate = selector(state, 'birthDate')
  const country = selector(state, 'country')
  const phoneNumber = selector(state, 'phoneNumber')
  const firstName = selector(state, 'firstName')
  const lastName = selector(state, 'lastName')
  const zip = selector(state, 'zip')
  const memberRetrieved = selector(state, 'memberRetrieved')
  const isBaseActive = selector(state, 'isBaseActive')
  const isCollegiateAdult = selector(state, 'isCollegiateAdult')
  const isCollegiateYouth = selector(state, 'isCollegiateYouth')
  const isJuniorGoldActive = selector(state, 'isJuniorGoldActive')
  const isJuniorGoldU12 = selector(state, 'isJuniorGoldU12')
  const isJuniorGoldU14 = selector(state, 'isJuniorGoldU14')
  const isJuniorGoldU16 = selector(state, 'isJuniorGoldU16')
  const isJuniorGoldU18 = selector(state, 'isJuniorGoldU18')
  const isJuniorGoldU15U18 = selector(state, 'isJuniorGoldU15U18')
  const isJuniorGoldU20 = selector(state, 'isJuniorGoldU20')
  const isJuniorGoldU15U17U20 = selector(state, 'isJuniorGoldU15U17U20')
  const isSpecialOlympicsYouth = selector(state, 'isSpecialOlympicsYouth')
  const isSpecialOlympicsAdult = selector(state, 'isSpecialOlympicsAdult')
  const isStandardYouth = selector(state, 'isStandardYouth')
  const isStandardAdult = selector(state, 'isStandardAdult')
  const membershipPurchaseDate = selector(state, 'membershipPurchaseDate')
  const middleInitial = selector(state, 'middleInitial')
  const suffix = selector(state, 'suffix')
  const divisionHeldId = selector(state, 'divisionHeldId')
  const norecordsfound = selector(state, 'norecordsfound')
  const mixedAgeDivisionsHeld = selector(state, 'mixedAgeDivisionsHeld')
  return {
    syncErrors,
    searchMode,
    eventId,
    memberidprefix,
    memberidsuffix,
    memberName,
    email,
    memberState,
    city,
    calculatedAge,
    gender,
    calculatedDivision,
    calculatedDivisionId,
    parentEmail,
    address1,
    address2,
    birthDate,
    country,
    phoneNumber,
    firstName,
    lastName,
    zip,
    memberRetrieved,
    isBaseActive,
    isCollegiateAdult,
    isCollegiateYouth,
    isJuniorGoldActive,
    isJuniorGoldU12,
    isJuniorGoldU14,
    isJuniorGoldU16,
    isJuniorGoldU18,
    isJuniorGoldU15U18,
    isJuniorGoldU20,
    isJuniorGoldU15U17U20,
    isSpecialOlympicsAdult,
    isSpecialOlympicsYouth,
    isStandardAdult,
    isStandardYouth,
    membershipPurchaseDate,
    middleInitial,
    suffix,
    divisionHeldId,
    norecordsfound,
    mixedAgeDivisionsHeld
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setSearchMode,
    fetchMember,
    savingAthlete,
    saveAdvancer,
    saveAlternate
  }, dispatch)
}

function validate(values, props) {
  const errors = []
  const { parentEmail, calculatedAge, birthDate, memberRetrieved, divisionHeldId, calculatedDivision, calculatedDivisionId, mixedAgeDivisionsHeld, memberidprefix, memberidsuffix } = values
  const { athleteType } = props;
  const mixedAgeDivisionHeld = mixedAgeDivisionsHeld.find(divisionsHeld => (divisionsHeld.id == divisionHeldId));
  const advancers = mixedAgeDivisionHeld.advancers;
  const alternates = mixedAgeDivisionHeld.alternates;
  let errorCounter = 0;
  if (!(memberidprefix == null || memberidsuffix == null)) {
    let duplicateFound = 0;
    const searchedMembershipId = memberidprefix + '-' + memberidsuffix;
    if (advancers.length > 0 && athleteType == 'Alternate') {
      duplicateFound = ((advancers.map(advancer => advancer.membershipId)).filter(memberId => memberId == searchedMembershipId).length > 0)
    }
    if (alternates.length > 0 && athleteType == 'Advancer') {
      duplicateFound = ((alternates.map(alternate => alternate.membershipId)).filter(memberId => memberId == searchedMembershipId).length > 0)
    }
    if (duplicateFound) {
      errors[errorCounter++] = 'Bowler cannot be an Advancer and Alternate on the same event.';
    }
    if (advancers.length > 0 && athleteType == 'Advancer') {
      duplicateFound = ((advancers.map(advancer => advancer.membershipId)).filter(memberId => memberId == searchedMembershipId).length > 0)
      if (duplicateFound) {
        errors[errorCounter++] = 'Bowler cannot be an Advancer multiple times on the same event.'
      }
    }
    if (alternates.length > 0 && athleteType == 'Alternate') {
      duplicateFound = ((alternates.map(alternate => alternate.membershipId)).filter(memberId => memberId == searchedMembershipId).length > 0)
      if (duplicateFound) {
        errors[errorCounter++] = 'Bowler cannot be an Alternate multiple times on the same event.'
      }
    }
  }

  if (memberRetrieved) {
    if (!birthDate) {
      errors[errorCounter++] = 'Athlete does not have a date of birth'
    }
    if (calculatedAge < 18 && !parentEmail) {
      errors[errorCounter++] = 'Parent/Guardian email is required for athletes under 18'
    }
    if (!isEmpty(parentEmail) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(parentEmail)) {
      errors[errorCounter++] = 'Parent/Guardian email is invalid'
    }
    if (divisionHeldId === undefined || divisionHeldId === '-1') {
      errors[errorCounter++] = 'Division held is required.'
    }
    if (isEmpty(calculatedDivision)) {
      errors[errorCounter++] = 'The Division through which the Athlete is selected to advance does not match the athletes division based on their Date of Birth and Gender'
    }
    if (isEmpty(calculatedDivisionId) && !isEmpty(calculatedDivision)) {
      errors[errorCounter++] = 'A division could not be found based on athletes Date of Birth and Gender'
    }
  }
  return errors
}

export default reduxForm({
  validate,
  form: FormName,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(NewAdvancerAlternate))


// WEBPACK FOOTER //
// ./src/containers/postevent/components/recordAthletes/newAdvancerAlternate.js